import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";

export class HorribleHeroesGameRoundPresentation implements GameRoundPresentation {
    private triggerStart: boolean;
    private triggerStop: boolean;

    constructor(triggerReelsStarted: boolean = false, triggerReelsStopped: boolean = false) {
        this.triggerStart = triggerReelsStarted;
        this.triggerStop = triggerReelsStopped;
    }

    /**
     * @inheritDoc
     * @param data
     */
    getAnimation(data: ParsedServerData): gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax | null {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {

            if (this.triggerStart) {
                EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED));
            } else if (this.triggerStop) {
                EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STOPPED));
            }
        })
        return tl;
    }
}